export default __webpack_public_path__ + "assets/1299b4bbde2ab489382efa986a72040c.svg";